// extracted by mini-css-extract-plugin
module.exports = {"fieldsetLegend":"FormFieldset_fieldsetLegend__2s-x5"};